import React from 'react';
import NewsPaper from '../components/newsPaper/news';

const PeriodicoDigitalPage = () => (
    <div className="peridico">
        <NewsPaper/>
    </div>
);

export default PeriodicoDigitalPage;